// Make inbox conversation table rows clickable. Delegated from document because
// the conversation list is swapped in via AJAX (inbox/conversations/index.js.erb)
// without a turbolinks:load event. Clicks on real links/buttons (e.g. the product
// link) navigate normally and do not trigger the row navigation.
$(document).on("click", "tr[data-href]", function (e) {
  if ($(e.target).closest("a, button").length) return

  var href = $(this).data("href")
  if (typeof Turbolinks !== "undefined") {
    Turbolinks.visit(href)
  } else {
    window.location.href = href
  }
})
